import togglePreloader from '../prelodaer-search/prelodaer-search';

export default new class SearchResult {
    constructor() {
        this.filterInputs =     document.querySelectorAll('.search__filter-input');

        this.rubrics =          document.querySelector('.search__filter-rubrics');
        this.rubricItem =       document.querySelectorAll('.search__filter-rubric');
        this.rubricsMenu =      document.querySelector('.search__filter-rubricMenu');
        this.rubricsActive =    document.querySelector('.search__filter-rubrics_active');

        this.authors =          document.querySelector('.search__filter-authors');
        this.authorItem =       document.querySelectorAll('.search__filter-author');
        this.authorsMenu =      document.querySelector('.search__filter-authorMenu');
        this.authorsActive =    document.querySelector('.search__filter-authors_active');

        this.filtersWrapper =   document.querySelector('.search__filters');
        this.filtersTitle =     document.querySelector('.search__filters-title');
        this.filtersContent =   document.querySelector('.search__filters__content');
        this.findBtn =          document.querySelector('.search__filters-apply');
        this.clearFiltersBtn =  document.querySelector('.search__filters-clear');
        this.filtersData =      document.querySelectorAll('.search__filter-radio, .search__filter-date, .search__filter-input, .search__filter-menuItem-input');
        this.sorts =            document.querySelectorAll('.search__sorts-btn');
        this.activeSort =       document.querySelector('.search__sorts-btn, .search__sorts-btn_active');

        this.searchInput =      document.querySelector('.search__input, .js-searchInput');

        this.searchPageURL =    'search-page';
        this.searchResult =     '.search__results';

        if ( document.body.getAttribute('data-page-id') === 'search') {
            this.bind()
        }
    }

    bind() {
        this.filterInputs.forEach(item => {
            item.addEventListener('focus', (e) =>{
                this.searchInSection.bind(this);
                this.searchInSection(e, item);
                this.showMenu.bind(this);
                this.showMenu(e)
            })
            item.addEventListener('input', (e) => {
                this.searchInSection.bind(this);
                this.searchInSection(e, item);
            });
        })

        document.addEventListener('click', this.hideMenu.bind(this));

        this.rubricItem.forEach(item => {
            item.addEventListener('click', (e) => {
                this.prependSelectedMenuItems.bind(this);
                this.prependSelectedMenuItems(e, 'rubric', this.rubricsActive);
                this.filterInputs.forEach((input) => {
                    input.value = ''
                })
            })
        })

        this.rubricsActive.addEventListener('click', this.deleteActiveRubric);
        this.authorsActive.addEventListener('click', this.deleteActiveRubric);

        this.authorItem.forEach(item => {
          item.addEventListener('click', (e) => {
            this.prependSelectedMenuItems.bind(this);
            this.prependSelectedMenuItems(e, 'author', this.authorsActive);
            this.filterInputs.forEach((input) => {
                input.value = ''
            })
          })
        })

        this.sorts.forEach(btn => {
            btn.addEventListener('click', this.setActiveSort.bind(this));
            btn.addEventListener('click', this.onRequestFilterData.bind(this));
        });
      this.findBtn.addEventListener('click', () => {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
          this.filtersContent.style.display = "none"
          this.filtersTitle.classList.remove('openned')
        }
            this.onRequestFilterData.bind(this);
        this.onRequestFilterData()

      })


        this.clearFiltersBtn.addEventListener('click', () => {

            if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                this.filtersContent.style.display = "none"
                this.filtersTitle.classList.remove('openned')
            }

            this.clearFilters.bind(this);
            this.clearFilters()

            this.onRequestFilterData.bind(this);
            this.onRequestFilterData()
        })

        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
            this.filtersTitle.addEventListener('click', () => {
                if (this.filtersContent.style.display == "none") {
                    this.filtersContent.style.display = "block"
                    this.filtersTitle.classList.add('openned')
                } else {
                    this.filtersContent.style.display = "none"
                    this.filtersTitle.classList.remove('openned')
                }
            })

            document.addEventListener( 'click', (e) => {
                const withinBoundaries = e.composedPath().includes(this.filtersWrapper);

                if (this.filtersContent.style.display == "block" && ! withinBoundaries ) {
                    this.filtersContent.style.display = 'none';
                    this.filtersTitle.classList.remove('openned')
                }
            })

            document.addEventListener( 'keydown', (e) => {
                if(this.filtersContent.style.display == "block"  &&  e.key == "Escape" ){
                    this.filtersContent.style.display = 'none';
                    this.filtersTitle.classList.remove('openned')
                }
            })
        }
    }

    showMenu(e) {
        if (e.target.id == 'filter-rubrics') {
          this.authorsMenu.classList.remove('search__filter-authorMenu_open');
          this.rubricsMenu.classList.add('search__filter-rubricMenu_open');
        } else if (e.target.id == 'filter-authors') {
          this.rubricsMenu.classList.remove('search__filter-rubricMenu_open');
          this.authorsMenu.classList.add('search__filter-authorMenu_open');
        }
    }

    hideMenu(e) {
        if (
            !e.target.classList.contains('search__filter-input') &&
            !e.target.classList.contains('search__filter-menuItem') &&
            (e.target.tagName != 'INPUT')
        ) {
            this.rubricsMenu.classList.remove('search__filter-rubricMenu_open');
            this.authorsMenu.classList.remove('search__filter-authorMenu_open');

            this.filterInputs.forEach((input) => {
                input.value = ''
            })
        }
    }

    prependSelectedMenuItems(e, section, sectionName) {
        if (e.target.tagName === 'LABEL') return;

        let items = [];

        document.querySelectorAll(`.search__filter-${section}`).forEach(item => {
            if (item.children.item(0).checked) {
                items.push([item.children.item(1).textContent, item.children.item(0).id]);
            }
        });

        sectionName.innerHTML = '';

        items.forEach(item => {
            let label = document.createElement('label');
            label.htmlFor = item[1]
            label.classList.add(`search__filter-${section}s_activeItem`);
            label.textContent = item[0];

            sectionName.append(label);
        });
    }

    deleteActiveRubric(e) {
        if (e.target.tagName == 'LABEL') setTimeout(() => e.target.remove(), 100);
    }


    searchInSection(e, itemSection) {
        let sectionName;
        if (e.target.id === 'filter-rubrics') sectionName = 'rubric';
        if (e.target.id === 'filter-authors') sectionName = 'author';

        const searchText = itemSection.value.trim().toLowerCase();
        const sections = document.querySelectorAll(`.search__filter-${sectionName}`);

        sections.forEach(section => {
            const label = section.querySelector('.search__filter-menuItem').textContent.trim().toLowerCase();
            if (label.includes(searchText)) {
                section.style.display = 'block';
            } else {
                section.style.display = 'none';
            }
        });
    }

    clearSearchInSection() {
      const sectionName = [
        'rubric', 'author'
      ];

      sectionName.forEach(section => {
        const sections = document.querySelectorAll(`.search__filter-${section}`);

        sections.forEach(item => {
          item.style.display = 'block';
        })
      })

    }

    clearFilters() {
        this.filtersData.forEach((input) => {
            if (input.type === 'radio') {
                if (input.checked && input.id !== 'all' && input.id !== 'any') {
                    input.checked = false;
                }

                if ((input.id === 'all' || input.id === 'any') && !input.checked) {
                    input.checked = true;
                }
            }

            if (input.type === 'text') input.value = '';

            if (input.type === 'checkbox' && input.checked) {
                input.checked = false;
                this.rubricsActive.innerHTML = '';
                this.authorsActive.innerHTML = '';
            }
        });

        this.clearSearchInSection();
    }

    getFiltersData() {
        let filters = {};

        // adding to filters active sort
        this.updateActiveSort();
        filters['search'] = this.searchInput.value;
        filters['sorting'] = this.activeSort.id;

        this.updateFiltersData(); // updating filtersData
        this.filtersData.forEach(item => {
            if (item.checked) {

                if (
                    item.dataset.filter === 'section' ||
                    item.dataset.filter === 'access'  ||
                    item.dataset.filter === 'journal'
                ) {
                    filters[item.dataset.filter] = item.id
                } else if (filters[item.dataset.filter] ) {
                    filters[item.dataset.filter].push(item.id)
                } else {
                    filters[item.dataset.filter] = [item.id];
                }
            }
        })

        return filters;
    }

    updateFiltersData() {
        this.filtersData = document.querySelectorAll('.search__filter-radio, .search__filter-input, .search__filter-menuItem-input');
    }

    updateActiveSort() {
        this.activeSort = document.querySelector('.search__sorts-btn_active');
    }

    setActiveSort(e) {
        this.sorts.forEach(btn => btn.classList.remove('search__sorts-btn_active'));
        e.target.classList.add('search__sorts-btn_active');
    }

    handleRequestFiltersData(filters) {

        if (filters['search'].length < 3) {
            return
        }

        let getReqStr = ''

        for (let item in filters) {
            if (filters[item]) {

                if (!Array.isArray(filters[item])) {
                    getReqStr += `${item}=${filters[item]}&`
                } else {
                    for (let subitem of filters[item]) {
                        getReqStr +=`${item}[]=${subitem}&`
                    }
                }
            }
        }

        getReqStr = getReqStr.slice(0, -1)

        window. scrollTo(0, 0)
        history.pushState(null, null,
            `/${this.searchPageURL}?${getReqStr}`)

        $(this.searchResult).html('')
        togglePreloader(true, $(this.searchResult));
        let header = document.querySelector('#search__request')
        $.request('ArticleList::onGetRequest', {
            data: filters,
            update: { 'project/common/search-page/search-results': '.search__results' },
            complete: (response) => {

                header.innerHTML = response.responseJSON.result
            },
        });
    }

    onRequestFilterData() {
        const filters = this.getFiltersData();
        this.handleRequestFiltersData(filters);
    }
}
